import { ILobbyMatchPrep, ILobbyPlayerMatchPrep } from '@nova/types';

// * Segregated for file to be client-compatible

export function createLobby(
  player: ILobbyPlayerMatchPrep,
  lobbyId: string,
  browserIndex: number,
  lobbyName: string,
  playerCap: number,
  playableMapIds: string[]
): ILobbyMatchPrep {
  const lobby: ILobbyMatchPrep = {
    id: lobbyId,
    browserIndex: browserIndex,
    lobbyName,
    players: [player],
    playerCap,
    playableMapIds,
    mapHighlightedId: playableMapIds[0],
    leader: player.id
  };

  return lobby;
}
